import { gql, useLazyQuery } from "@apollo/client";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectAccountOnboarding, ConnectComponentsProvider, ConnectPayments } from "@stripe/react-connect-js";
import { useEffect, useState } from "react";
import images from "../../../assets/images";
import { ACCOUNT_SESSION } from "./api/PaymentInfoQuery";
import ToasterWithMessage from "../toaster";
import styles from './paymentinfo.module.css'
const PaymentInfo = () => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const { QuickAsystIcon } = images;
  const { error } = ToasterWithMessage();
  useEffect(() => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const encodeActid: string | null = urlParams.get('actid');
        const decodedActId: string = encodeActid ? atob(encodeActid) : '';
        if(decodedActId) {
          accountSessionQuery({
            variables: {
                accountId: decodedActId
            }
          });
        } else {
          setErrorMessage(true)
        }
    } catch(err: any) {
       console.log(err,"==err")
       error('Something went wrong!')
       setErrorMessage(true)
    }
  },[])

  const [accountSessionQuery] = useLazyQuery(ACCOUNT_SESSION, {
    fetchPolicy: "no-cache",
    onCompleted: (response) => {
      if (response) {
        loadStripeConnectInstance(response.accountSession.key);
      } else {
        console.error("An error occurred");
        setErrorMessage(true)
        error('Failed to fetch Account')
      }
    },
    onError: (err) => {
      console.log(err,"===err onerros", err?.message)
      error(err?.message);
    }
  });

  const loadStripeConnectInstance = async (clientSecret: string) => {
    const stripeInstance = loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? '',
      fetchClientSecret: () => Promise.resolve(clientSecret)
    });
    setStripeConnectInstance(stripeInstance);
  };


  return (
    <>

      <div style={{margin: 0,display: 'flex', flexDirection: 'column', position: 'absolute', top: 0,bottom: 0, right: 0, left: 0}}>
       <div 
       style = {{backgroundColor: '#151A34', width: '100%', display: "flex", alignItems: "center", justifyContent: "center", position: "sticky", top: 0, zIndex: 1000}}
       >
       <div>
        <img
          style={{width: '150px'}}
          alt="sidebarLogo"
          src={QuickAsystIcon}
          data-testid="sidebarLogo"
        />
      </div>
       </div>
      <div style={{flex: 1}}>
      {
        errorMessage && 
        <div style = {{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
          Page not found!
        </div>
      }
      {
        stripeConnectInstance && 
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectAccountOnboarding
              onExit={() => {
                console.log("The account has exited onboarding");
              }}
              // Optional: make sure to follow our policy instructions above
              fullTermsOfServiceUrl={process.env.REACT_APP_TERMS_OF_SERVICE}
              privacyPolicyUrl={process.env.REACT_APP_PRIVACY_POLICY}
            />
        </ConnectComponentsProvider>
      }
      </div>
      <div className={styles.imageContainerPowered}>
        <span className="message">Powered by Stripe</span>
    </div>
    </div>
    </>
  );
};

export default PaymentInfo;
